<template>
  <div
    class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full"
  >
    <div class="px-4 py-3 sm:px-4">
      <div
        class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap"
      >
        <div class="ml-4 mt-2">
          <h3 class="text-base leading-6 font-medium text-gray-900">
            {{ $t('message.reports.indicadores.totaldiario') }}: <b>{{this.currentDevice.name}}</b>
          </h3>
        </div>
        <span class="relative z-0 inline-flex rounded-md">
          <div class="ml-2 mt-2 flex-shrink-0">
              <select @change="fetchData()" id="ind" v-model="indicator" class="block w-full pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                <option v-for="i in indicators" v-bind:key="i.key" v-bind:value="i.key"> {{i.name}} </option>
              </select>
          </div>
          <div class="ml-2 mt-2 flex-shrink-0">
            <button
              @click="downloadExcel"
              type="button"
              class="relative inline-flex items-center px-2 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <svg
                v-if="downloading"
                class="animate-spin -ml-1 mr-3 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {{ $t('message.reports.detenciones.descargarexcel') }}
            </button>
          </div>
        </span>
      </div>
    </div>
    <div class="px-4 py-6">
      <div id="chart2">
        <vue-apex-charts
          type="line"
          height="200"
          :options="dayOptions"
          :series="seriesDay"
        ></vue-apex-charts>
      </div>
    </div>
    <div class="px-4 py-3 sm:px-4">
      <div
        class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap"
      >
        <div class="ml-4 mt-2">
          <h3 class="text-base leading-6 font-medium text-gray-900">
            {{ $t('message.reports.indicadores.totalmensual') }}: <b>{{this.currentDevice.name}}</b>
          </h3>
        </div>
      </div>
    </div>
    <div class="px-4 py-6">
      <div id="chart3">
        <vue-apex-charts
          type="line"
          height="200"
          :options="monthOptions"
          :series="seriesMonth"
        ></vue-apex-charts>
      </div>
    </div>
  </div>

</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import { getUnixTime } from 'date-fns';
import axios from 'axios';
export default {
  name: 'report-detenciones',
  components: { VueApexCharts },
  mounted() {
    this.fetchIndicators()
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    currentDevice: {
      type: Object,
      required: true
    },
    reportnav: {
      type: Object
    }
  },
  watch: {
    range() {
      this.fetchData();
    },
    currentDevice() {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      const start = getUnixTime(this.range.start);
      const end = getUnixTime(this.range.end);
      const response = await this.$http.get(`/indicators?start=${start}&end=${end}&indicator=${this.indicator}&devid=${this.currentDevice.devid}`);
      this.seriesDay = response.data.day_indicators;
      this.seriesMonth = response.data.month_indicators;
      this.daytimestamps= this.seriesDay[0].timestamps
      this.monthtimestamps = this.seriesMonth[0].timestamps
      console.log('series', this.seriesDay)
      console.log('series', this.seriesMonth)
    },

    async fetchIndicators() {
      const response = await this.$http.get(`/indicatornames`);
      this.indicators = response.data;
      this.indicator = this.indicators[0].key
      this.fetchData();
    },
    async downloadExcel() {
      this.downloading = true;
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const url = `reports?report=indicators&start=${start}&end=${end}&device=${this.currentDevice.devid}`;
      let response = await this.$http.get(url);
      if (response.status === 200) {
        const baseURL = process.env.VUE_APP_ROOT_API;
        const url = baseURL + 'reports?report=get_report&filename=' + response.data;
        axios
          .get(url, { responseType: 'blob', headers: {'Authorization': `JWT ${this.$store.getters.auth.token}`}})
          .then(r => {
            const blob = new Blob([r.data], {
              type: 'application/vnd.ms-excel'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            console.log('response', response.data);
            link.download = response.data;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }
      this.downloading = false;
    }
  },
  data() {
    return {
      downloading: false,
      seriesDay: [],
      daytimestamps: [],
      monthtimestamps: [],
      seriesMonth: [],
      dayOptions: {
        labels: this.monthtimestamps,
        dataLabels: {
          enabled: false,
          formatter: function (val) {
            return val + "%";
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        legend: {
          formatter: (seriesName) => this.indicators.find(element => element.key===seriesName).name,
        },
        stroke: {
          show: true,
        },
        fill: {
          opacity: 1
        },
        yaxis: {
          min:0,
          decimalsInFloat:0

        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + '%';
            },
            title: {
              formatter: (seriesName) => this.indicators.find(element => element.key===seriesName).name,
            },
          }
        }
      },
      monthOptions: {
        chart: {
          height: 350,
        },
        legend: {
          formatter: (seriesName) => this.indicators.find(element => element.key===seriesName).name,
        },
        stroke: {
          show: true,
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [0]
        },
        labels: this.monthtimestamps,
        markers: {
          size: 0
        },
        xaxis: {
        },
        yaxis: {
          min:0,
          decimalsInFloat:0

        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + '%';
            },
            title: {
              formatter: (seriesName) => this.indicators.find(element => element.key===seriesName).name,
            },
          }
        }
      },

      indicators: [{'key': 'oee', 'name': 'OEE'}],
      indicator: 'oee'
    };
  }
};
</script>
